import { AZURE_URL } from "../constants/env-constants";

export const getAllRoles = async () => {
  try {
    const response = await AZURE_URL.get("/user/allRoles");
    return [response.data, null];
  } catch (error: any) {
    return error.response;
  }
};

export const getAllUsers = async () => {
  try {
    const response = await AZURE_URL.get("/user/get/all");
    return [response.data, null];
  } catch (error: any) {
    return error.response;
  }
};

export const getUserDetails = async () => {
  try {
    const response = await AZURE_URL.get("/user/get");
    return response;
  } catch (error: any) {
    return error;
  }
};

export const createUser = async (userData: CreateUser) => {
  try {
    const response = await AZURE_URL.post("/user/adminSignUp", userData);
    return [response.data, null];
  } catch (error: any) {
    return [null, error.response];
  }
};

export const createStaff = async (staffData: CreateStaff) => {
  try {
    const response = await AZURE_URL.post("/staff/create", staffData);
    return [response.data, null];
  } catch (error: any) {
    return [null, error.response];
  }
};
export const deleteUser = async (username: string) => {
  try {
    const response = await AZURE_URL.delete(
      `/user/delete?usernameToDelete=${username}`
    );
    return [`User ${username} deleted successfully`, null];
  } catch (error: any) {
    return [null, error.response || error.message];
  }
};

export const reset2FA = async (req: ResetAuthRequest) => {
  try {
    const response = await AZURE_URL.put("/user/admin/resetAuth", req);
    return [response, null];
  } catch (error: any) {
    return [null, error.response];
  }
};
